"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/values"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

require("../../util/GlobalScript.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CollapsibleLink = _interopRequireDefault(require("../general/CollapsibleLink"));

var _DetailsTooltip = _interopRequireDefault(require("../tooltips/DetailsTooltip"));

var _classnames = _interopRequireDefault(require("classnames"));

var _StateContainer = require("../utils/StateContainer");

var _DeprecationUtils = require("../../util/DeprecationUtils");

var _Disabled = _interopRequireDefault(require("../layout/Disabled"));

var _PropUtils = require("../../util/PropUtils");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @enum {string}
 * @alias LinkDropDownList.alignments
 */
var alignments = {
  /** left */
  LEFT: "left",

  /** right */
  RIGHT: "right"
};
/**
 * @callback LinkDropDownList~onClick
 * @param {object} selectedMenuItem
 *     The data object of the selected/clicked menu item
 */

/**
 * @callback LinkDropDownList~onToggle
 */

/**
 * @class LinkDropDownListOption
 * @param {string} [data-id=link-dropdown-option]
 *     The "data-id" value for top-level HTML container.
 * @param {boolean} [disabled]
 *     dropdown option will not function when true.
  * @param {object} option
 *     Array of group sections for the linkDropDownList.
 * @param {boolean} selected
 *    The selected list option.
 */

/**
 * @class LinkDropDownList
 * @desc Toggles between two states on click. Is either "off" or "on".
 *
 * @param {LinkDropDownList.alignments} [alignment=left]
 *     Right or left alignment of the dropdown.
 * @param {string} [data-id=toggle]
 *     The "data-id" value for top-level HTML container.

 * @param {node} [label]
 *     A string or JSX object that serves as the trigger label.
 * @param {string} [className]
 *     CSS classes to be set on the top-level HTML container.
 *
 * @param {object} [bottomPanel]
 *     Link actions for the bottom of the list
 *
 * @param {boolean} [stateless]
 *     Enables whether the open state of teh component to be externally managed. True will relinquish control to the
 *     component's parent component. False or not specified will cause the component to manage state internally.
 * @param {boolean} [open=false]
 *     Determines whether the LinkDropDownList is visible. True = visible, False = hidden.
 *     When not provided, the component will manage this value.
 * @param {object} [initialState]
 *     selectedOption determines the initial state of 'selectedOption'.
 * @param {function} [renderLink]
 *     Function to render the CollapsibleLink.
 * @param {FormDropDownList~option} selectedOption
 *     The selected list option.
 *     When not provided, the component will manage this value.
 * @param {node} topPanel
 *     When provided, render content above the options in the dropdown.
 * @param {LinkDropDownList~onClick} [onClick]
 *     Callback triggered when a menu item is selected
 * @param {LinkDropDownList~onToggle} [onToggle]
 *     Callback triggered when the menu visibility is changed
 *
 * @example
 *     <LinkDropDownList
 *         options={data.options}
 *         selectedOption={this.state.selectedOption}
 *         onClick{this._handleClick}
 *         onToggle={this._handleToggle}
 *     />
 */

var LinkDropDownListStateless = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(LinkDropDownListStateless, _React$Component);

  var _super = _createSuper(LinkDropDownListStateless);

  function LinkDropDownListStateless() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, LinkDropDownListStateless);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat.default)(_context = [this]).call(_context, args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_handleClick", function (selectedOption) {
      if (_this.props.closeOnSelection) {
        _this.props.onToggle();
      }

      if (_this.props.onClick) {
        _this.props.onClick(selectedOption);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_renderLabel", function () {
      return _this.props.renderLink({
        className: "link-dropdown-list__link",
        "data-id": _this.props["data-id"] + "-label",
        expanded: _this.props.open,
        title: _this.props.label,
        arrowPosition: _this.props.labelArrowPosition
      }, _CollapsibleLink.default);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_renderOptions", function () {
      var _context2;

      return (0, _map.default)(_context2 = _this.props.options).call(_context2, function (option, i) {
        return /*#__PURE__*/_react.default.createElement(LinkDropDownListOption, {
          "data-id": "list-option-".concat(option.value),
          key: i,
          onClick: _this._handleClick,
          option: option,
          selected: option === _this.props.selectedOption,
          disabled: option.disabled
        });
      });
    });
    return _this;
  }

  (0, _createClass2.default)(LinkDropDownListStateless, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement(_DetailsTooltip.default, {
        "data-id": this.props["data-id"],
        placement: this.props.alignment === alignments.RIGHT ? _DetailsTooltip.default.tooltipPlacements.BOTTOM_LEFT : _DetailsTooltip.default.tooltipPlacements.BOTTOM_RIGHT,
        contentClassName: "link-dropdown-list",
        className: (0, _classnames.default)(this.props.className, "link-dropdown-list"),
        label: this._renderLabel(),
        showClose: false,
        open: this.props.open,
        onToggle: this.props.onToggle
      }, this.props.topPanel && /*#__PURE__*/_react.default.createElement("div", {
        "data-id": this.props["data-id"] + "-top-panel",
        className: "list-input__top-panel"
      }, this.props.topPanel), /*#__PURE__*/_react.default.createElement("ul", {
        className: "select-list",
        "data-id": this.props["data-id"] + "-menu"
      }, this._renderOptions()), this.props.bottomPanel && /*#__PURE__*/_react.default.createElement("div", {
        "data-id": this.props["data-id"] + "-bottom-links",
        className: "list-input__bottom-links"
      }, this.props.bottomPanel));
    }
  }]);
  return LinkDropDownListStateless;
}(_react.default.Component);

(0, _defineProperty2.default)(LinkDropDownListStateless, "propTypes", {
  alignment: _propTypes.default.oneOf((0, _values.default)(alignments)),
  className: _propTypes.default.string,
  "data-id": _propTypes.default.string,
  label: _propTypes.default.node,
  labelArrowPosition: _propTypes.default.oneOf((0, _values.default)(_CollapsibleLink.default.arrowPositions)),
  onClick: _propTypes.default.func,
  onToggle: _propTypes.default.func,
  open: _propTypes.default.bool,
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.node,
    disabled: _propTypes.default.bool,
    value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired
  })),
  renderLink: _propTypes.default.func,
  selectedOption: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.oneOf([-1])]) // -1 means no value has been set

});
(0, _defineProperty2.default)(LinkDropDownListStateless, "defaultProps", {
  closeOnSelection: true,
  "data-id": "link-dropdown-list",
  renderLink: _PropUtils.defaultRender
});
var LinkDropDownList = (0, _StateContainer.inStateContainer)([{
  name: "open",
  initial: false,
  callbacks: [{
    name: "onToggle",
    transform: _StateContainer.toggleTransform
  }]
}, {
  name: "selectedOption",
  initial: -1,
  setter: "onClick"
}])(LinkDropDownListStateless);
LinkDropDownList.displayName = "LinkDropDownList";
LinkDropDownList.propTypes = {
  stateless: _DeprecationUtils.deprecatedStatelessProp
};
LinkDropDownList.labelArrowPositions = _CollapsibleLink.default.arrowPositions;
LinkDropDownList.alignments = alignments;

var LinkDropDownListOption = /*#__PURE__*/function (_React$Component2) {
  (0, _inherits2.default)(LinkDropDownListOption, _React$Component2);

  var _super2 = _createSuper(LinkDropDownListOption);

  function LinkDropDownListOption() {
    var _context3;

    var _this2;

    (0, _classCallCheck2.default)(this, LinkDropDownListOption);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = _super2.call.apply(_super2, (0, _concat.default)(_context3 = [this]).call(_context3, args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "_handleClick", function () {
      if (!_this2.props.disabled) {
        return _this2.props.onClick(_this2.props.option);
      }
    });
    return _this2;
  }

  (0, _createClass2.default)(LinkDropDownListOption, [{
    key: "render",
    value: function render() {
      var classNames = {
        "select-option": true,
        disabled: this.props.disabled,
        selected: this.props.selected
      };

      var list = /*#__PURE__*/_react.default.createElement("li", {
        "data-id": this.props["data-id"],
        "data-value": this.props.option.value,
        className: (0, _classnames.default)(classNames),
        onClick: this._handleClick,
        tabIndex: "0"
      }, this.props.option.label);
      /* istanbul ignore if  */


      if (this.props.disabled) {
        return /*#__PURE__*/_react.default.createElement(_Disabled.default, null, list);
      } else {
        return list;
      }
    }
  }]);
  return LinkDropDownListOption;
}(_react.default.Component);

(0, _defineProperty2.default)(LinkDropDownListOption, "propTypes", {
  "data-id": _propTypes.default.string,
  disabled: _propTypes.default.bool,
  option: _propTypes.default.object,
  selected: _propTypes.default.bool
});
(0, _defineProperty2.default)(LinkDropDownListOption, "defaultProps", {
  "data-id": "link-dropdown-option",
  disabled: false
});
var _default = LinkDropDownList;
exports.default = _default;
module.exports = exports["default"];